module.exports = __webpack_public_path__ + "img/pvc_expomoda_shiny_0103_gold_250x250.711db723.jpg";